import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IGetItemsResult } from '../../../../httpClient/serverApi/types/IGetItemsResult';
import { IConnectedDevice } from '../types/connectedDevices/IConnectedDevice';

export interface IGetUserConnectedDevicesParams {
  userId: string;
}

export interface IGetUserConnectedDevicesResult extends IGetItemsResult {
  devices: IConnectedDevice[];
}

export class GetUserConnectedDevicesRequest extends Request<IGetUserConnectedDevicesParams, IGetUserConnectedDevicesResult> {
  constructor(params: IGetUserConnectedDevicesParams) {
    super('getUserConnectedDevices', params);
  }
}
